/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {DB_Patient} from "@app/app-shared/patient";
import {AppointmentModule, OnAppointmentUpdated} from "@modules/AppointmentModule";
import {ICONS} from "@res/icons";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {DateTimesUtil} from "./DateTimesUtil";
import {AppointmentDialog} from "./AppointmentDialog";
import * as React from "react";

type Props = {
    patient: DB_Patient;
}

type State = {}

export class Appointment
    extends BaseComponent<Props, State>
    implements OnAppointmentUpdated {

    componentDidMount() {
        if (!AppointmentModule.isEnabled())
            return;

        const patient = this.props.patient;
        if (!patient)
            return;

        AppointmentModule.fetchAppointmentsForPatient(patient);
    }

    __onAppointmentUpdated(): void {
        this.forceUpdate();
    }

    render() {
        if (!AppointmentModule.isEnabled())
            return null;

        const appointment = AppointmentModule.getNextAppointment(this.props.patient);

        return (
            <div className={`ll_h_c`} style={{marginRight: 30}}>
                {
                    appointment !== undefined ? (
                        <>
                            {ICONS.doctor_appointment(COLORS.neutral_text_dark_2, 22)}
                            {FONTS.reg_16_dark("Next appointment: ", {marginLeft: 15, marginRight: 5})}
                            <div
                                onClick={() => {
                                    AppointmentDialog.show({patient: this.props.patient});
                                }}
                                style={{
                                    cursor: "pointer"
                                }}
                            >
                                {FONTS.bold_16_primary_blue(DateTimesUtil.appointmentPresentation(appointment.startTime, this.props.patient.timezone),
                                    {textDecoration: "underline"})}
                            </div>
                        </>
                    ) : (
                        <div
                            onClick={() => {
                                AppointmentDialog.show({patient: this.props.patient});
                            }}
                            style={{
                                alignItems: "center",
                                display: "flex",
                                backgroundColor: COLORS.primary_blue,
                                borderRadius: 4,
                                cursor: "pointer",
                                minHeight: 40,
                                padding: "0 10px",
                                textAlign: "center"
                            }}
                        >
                            {ICONS.doctor_appointment(COLORS.white, 22)}
                            {FONTS.medium_16_white("Add appointment", {marginLeft: 5})}
                        </div>
                    )
                }
            </div>
        );
    };
}
